import { render, staticRenderFns } from "./book-insight.vue?vue&type=template&id=3ace2326&scoped=true&"
import script from "./book-insight.vue?vue&type=script&lang=js&"
export * from "./book-insight.vue?vue&type=script&lang=js&"
import style0 from "./book-insight.vue?vue&type=style&index=0&id=3ace2326&prod&lang=scss&scoped=true&"
import style1 from "./book-insight.vue?vue&type=style&index=1&id=3ace2326&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ace2326",
  null
  
)

export default component.exports